import type { JSX } from "react";
import type { AnalyticsDailyStatsRow } from "@/features/analytics/types";
import { AnalyticsEmptyState } from "./AnalyticsEmptyState";
import { AnalyticsLoadingState } from "./AnalyticsLoadingState";
import { DailyStatsTable } from "./DailyStatsTable";

type AnalyticsResultsPanelProps = {
  rows: AnalyticsDailyStatsRow[];
  isLoading: boolean;
  resultsLabel: string;
};

export const AnalyticsResultsPanel = ({
  rows,
  isLoading,
  resultsLabel,
}: AnalyticsResultsPanelProps): JSX.Element => {
  return (
    <div className="flex min-w-0 flex-col">
      {isLoading ? (
        <AnalyticsLoadingState />
      ) : rows.length > 0 ? (
        <DailyStatsTable rows={rows} />
      ) : (
        <AnalyticsEmptyState />
      )}

      <div className="mt-[22px] text-[13px] text-(--text-muted)">
        {resultsLabel}
      </div>
    </div>
  );
};
